import { TextField } from "@goodgamestudios/createjs-utilities";
import { classImplementsInterfaces } from "@goodgamestudios/createjs-utilities";
import { AbstractTeaser } from "./common/AbstractTeaser";
import { TeaserTextsVO } from "./common/TeaserTextsVO";
import { TeaserVO } from "./common/TeaserVO";

import MovieClip = createjs.MovieClip;

export class SlotmachineTeaser extends AbstractTeaser {
    private _txtTitle: TextField;
    private _btnOk: MovieClip;
    constructor(featureId: number, teaserMc: MovieClip, teaserVO: TeaserVO) {
        super(featureId, teaserMc, teaserVO);
    }

    protected buildHook(): void {
        this._txtTitle = this._teaserMc.txt_title;
        this._btnOk = this._teaserMc.btn_ok;
    }

    public fillTexts(vo: TeaserTextsVO): void {
        super.fillTexts(vo);

        this._txtTitle.text = vo.titleStr;
    }

    public fillButtonLabels(vo: TeaserTextsVO = null): void {
        var textVO: TeaserTextsVO = (vo == null) ? this._teaserVO.teaserTextsVO : vo;

        this._btnOk.label = textVO.btnOkLabel;
    }
}
classImplementsInterfaces(SlotmachineTeaser, "Container");
